import type { ReactNode } from "react";

type EyebrowProps = {
  children: ReactNode;
  tone?: "dark" | "light";
  className?: string;
};

export default function Eyebrow({ children, tone = "dark", className = "" }: EyebrowProps) {
  return (
    <span
      className={`inline-flex items-center gap-3 font-label text-[11px] font-medium uppercase tracking-[0.24em] ${
        tone === "light" ? "text-accent-300" : "text-accent-700"
      } ${className}`}
    >
      <span className="h-px w-7 bg-current opacity-70" />
      {children}
    </span>
  );
}